function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return generator._invoke = function (innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; }(innerFn, self, context), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; this._invoke = function (method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (object) { var keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// @ts-nocheck
import { Component, createContext, useContext } from "react";
import h from "@macrostrat/hyper";
import { DateInput } from "@blueprintjs/datetime";
import { EditableText } from "@blueprintjs/core";
import { EditButton } from "./buttons";
import { StatefulComponent } from "./util";
import classNames from "classnames";
import update from "immutability-helper";
import "@blueprintjs/datetime/lib/css/blueprint-datetime.css";
var ModelEditorContext = /*#__PURE__*/createContext({});

function ModelEditButton(props) {
  var _useContext = useContext(ModelEditorContext),
      isEditing = _useContext.isEditing,
      actions = _useContext.actions;

  return h(EditButton, _objectSpread({
    isEditing: isEditing,
    onClick: actions.toggleEditing
  }, props));
}

var ModelEditor = /*#__PURE__*/function (_StatefulComponent) {
  _inherits(ModelEditor, _StatefulComponent);

  var _super = _createSuper(ModelEditor);

  function ModelEditor(props) {
    var _this;

    _classCallCheck(this, ModelEditor);

    _this = _super.call(this, props);
    _this.getValue = _this.getValue.bind(_assertThisInitialized(_this));
    _this.hasChanges = _this.hasChanges.bind(_assertThisInitialized(_this));
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.toggleEditing = _this.toggleEditing.bind(_assertThisInitialized(_this));
    _this.persistChanges = _this.persistChanges.bind(_assertThisInitialized(_this));
    _this.onPersistChanges = _this.onPersistChanges.bind(_assertThisInitialized(_this));
    _this.state = {
      isEditing: props.isEditing || false,
      isPersisting: null,
      error: null,
      model: props.model,
      initialModel: props.model
    };
    return _this;
  }

  _createClass(ModelEditor, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var model = this.state.model;
      var canEdit = this.props.canEdit;
      var isEditing = this.state.isEditing && canEdit;

      var actions = function () {
        var _this3;

        var onChange, persistChanges, toggleEditing, updateState;
        return _this3 = _this2, onChange = _this3.onChange, toggleEditing = _this3.toggleEditing, updateState = _this3.updateState, persistChanges = _this3.persistChanges, _this3;
      }();

      var value = {
        actions: actions,
        model: model,
        isEditing: isEditing,
        canEdit: canEdit,
        hasChanges: this.hasChanges
      };
      return h(ModelEditorContext.Provider, {
        value: value
      }, this.props.children);
    }
  }, {
    key: "getValue",
    value: function getValue(field) {
      return this.state.model[field];
    }
  }, {
    key: "hasChanges",
    value: function hasChanges(field) {
      if (field == null) {
        return this.state.initialModel !== this.state.model;
      }

      return this.state.initialModel[field] !== this.state.model[field];
    }
  }, {
    key: "onChange",
    value: function onChange(field) {
      var _this4 = this;

      return function (value) {
        // @ts-ignore
        return _this4.updateState({
          model: _defineProperty({}, field, {
            $set: value
          })
        });
      };
    }
  }, {
    key: "toggleEditing",
    value: function toggleEditing() {
      var spec = {
        $toggle: ["isEditing"]
      };

      if (this.state.isEditing) {
        spec.model = {
          $set: this.state.initialModel
        };
      }

      return this.updateState(spec);
    }
  }, {
    key: "onPersistChanges",
    value: function onPersistChanges() {
      return this.persistChanges(null);
    }
  }, {
    key: "persistChanges",
    value: function () {
      var _persistChanges = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(spec) {
        var persistChanges, updatedModel, ret, changeset, k, _v, newModel;

        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                persistChanges = this.props.persistChanges; // Persist changes expects a promise

                updatedModel = this.state.model;

                if (spec != null) {
                  // If changeset is provided, we need to integrate
                  // it before proceeding
                  console.log(spec);
                  updatedModel = update(this.state.model, spec);
                }

                console.log(updatedModel);
                ret = null;

                if (!(persistChanges == null)) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", null);

              case 7:
                _context.prev = 7;
                this.updateState({
                  isPersisting: {
                    $set: true
                  }
                }); // Compute a shallow changeset of the model fields

                changeset = {};
                _context.t0 = _regeneratorRuntime().keys(updatedModel);

              case 11:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 19;
                  break;
                }

                k = _context.t1.value;
                _v = updatedModel[k];

                if (!(_v === this.state.initialModel[k])) {
                  _context.next = 16;
                  break;
                }

                return _context.abrupt("continue", 11);

              case 16:
                changeset[k] = _v;
                _context.next = 11;
                break;

              case 19:
                _context.next = 21;
                return persistChanges(updatedModel, changeset);

              case 21:
                ret = _context.sent;
                _context.next = 27;
                break;

              case 24:
                _context.prev = 24;
                _context.t2 = _context["catch"](7);
                console.error(_context.t2);

              case 27:
                _context.prev = 27;
                spec = {
                  isPersisting: {
                    $set: false
                  }
                };

                if (ret != null) {
                  // @ts-ignore
                  newModel = update(this.state.initialModel, {
                    $merge: ret
                  });
                  console.log(newModel);
                  spec.model = {
                    $set: newModel
                  };
                  spec.initialModel = {
                    $set: newModel
                  };
                }

                this.updateState(spec);
                return _context.finish(27);

              case 32:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 24, 27, 32]]);
      }));

      function persistChanges(_x) {
        return _persistChanges.apply(this, arguments);
      }

      return persistChanges;
    }()
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps == null) {
        return;
      }

      if (prevProps === this.props) {
        return;
      }

      var spec = {};

      if (this.props.isEditing !== prevProps.isEditing && this.props.isEditing !== this.state.isEditing) {
        spec.isEditing = {
          $set: this.props.isEditing
        };
      }

      if (this.props.model !== prevProps.model) {
        spec.initialModel = {
          $set: this.props.model
        };

        if (!this.props.isEditing) {
          // If we aren't in edit mode, we want to propagate changes into the model
          spec.model = {
            $set: this.props.model
          };
        }
      }

      return this.updateState(spec);
    }
  }]);

  return ModelEditor;
}(StatefulComponent);

_defineProperty(ModelEditor, "defaultProps", {
  canEdit: true
});

function EditableMultilineText(props) {
  var field = props.field,
      className = props.className;

  var _useContext2 = useContext(ModelEditorContext),
      actions = _useContext2.actions,
      model = _useContext2.model,
      isEditing = _useContext2.isEditing;

  var value = model[field];
  var onChange = actions.onChange(field);
  className = classNames(className, "field-".concat(field));

  if (isEditing) {
    value = h(EditableText, {
      placeholder: "Edit ".concat(field),
      multiline: true,
      className: className,
      onChange: onChange,
      value: value
    });
  }

  return h("div.text", {
    className: className
  }, value);
}

var EditableDateField = /*#__PURE__*/function (_Component) {
  _inherits(EditableDateField, _Component);

  var _super2 = _createSuper(EditableDateField);

  function EditableDateField() {
    _classCallCheck(this, EditableDateField);

    return _super2.apply(this, arguments);
  }

  _createClass(EditableDateField, [{
    key: "render",
    value: function render() {
      var field = this.props.field;
      var _this$context = this.context,
          actions = _this$context.actions,
          model = _this$context.model,
          isEditing = _this$context.isEditing;
      var value = model[field];

      if (!isEditing) {
        return h("div.date-input.disabled", value);
      }

      return h(DateInput, {
        className: "date-input",
        value: new Date(value),
        formatDate: function formatDate(date) {
          return date.toLocaleDateString();
        },
        placeholder: "MM/DD/YYYY",
        showActionsBar: true,
        onChange: actions.onChange(field),
        parseDate: function parseDate(d) {
          return new Date(d);
        }
      });
    }
  }]);

  return EditableDateField;
}(Component);

_defineProperty(EditableDateField, "contextType", ModelEditorContext);

var useModelEditor = function useModelEditor() {
  return useContext(ModelEditorContext);
};

export { ModelEditor, ModelEditorContext, ModelEditButton, EditableMultilineText, EditableDateField, useModelEditor };